import { Component } from '@angular/core';

@Component({
  selector: 'app-surveillances-landing',
  templateUrl: './surveillances-landing.component.html',
  styleUrls: ['./surveillances-landing.component.scss']
})
export class SurveillancesLandingComponent {

}
